import { defineMessages } from 'react-intl';

import { Urls } from '../constants/Urls';

export const FooterMessages = defineMessages({
  about: {
    id: 't.about',
    defaultMessage: 'About',
  },
  jobs: {
    id: 't.jobs',
    defaultMessage: 'Jobs',
  },
  advertising: {
    id: 't.advertising',
    defaultMessage: 'Advertising',
  },
  businesses: {
    id: 't.businesses',
    defaultMessage: 'Businesses',
  },
  forArtist: {
    id: 't.forArtists',
    defaultMessage: 'For Artists',
  },
  investor: {
    id: 't.investor',
    defaultMessage: 'Investor',
  },
  blog: {
    id: 't.blog',
    defaultMessage: 'Blog',
  },
  gifts: {
    id: 't.gifts',
    defaultMessage: 'Gifts',
  },
  help: {
    id: 't.help',
    defaultMessage: 'Help',
  },
  community: {
    id: 't.community',
    defaultMessage: 'Community',
  },
  privacy: {
    id: 't.privacy',
    defaultMessage: 'Privacy',
  },
  terms: {
    id: 't.terms',
    defaultMessage: 'Terms',
  },
  adPreferences: {
    id: 't.adPreferences',
    defaultMessage: 'Ad Preferences',
  },
  copyright: {
    id: 't.copyright',
    defaultMessage:
      '© {date} Pandora Media, LLC, All Rights Reserved. Pandora and the Music Genome Project are registered trademarks of Pandora Media, LLC.',
  },
  signUp: {
    id: 't.signUp',
    defaultMessage: 'Sign up to start listening for free.',
  },
  signUpNow: {
    id: 't.signUpNow',
    defaultMessage: 'Sign Up Now',
  },
  doNotSell: {
    id: 't.doNotSell',
    defaultMessage: 'Do Not Sell My Personal Information',
  },
  yourPrivacyChoices: {
    id: 't.yourPrivacyChoices',
    defaultMessage: 'Your Privacy Choices',
  },
  cookieSettings: {
    id: 't.cookieSettings',
    defaultMessage: 'Cookie Settings',
  },
});

export const footerNavLinks = [
  [FooterMessages.about, `${Urls.ABOUT}`],
  [FooterMessages.jobs, `${Urls.CAREERS}`],
  [FooterMessages.advertising, `${Urls.ADVERTISING}`],
  [FooterMessages.businesses, `${Urls.BUSINESS}`],
  [FooterMessages.forArtist, `${Urls.AMP}`],
  [FooterMessages.investor, `${Urls.INVESTOR}`],
  [FooterMessages.blog, `${Urls.BLOG}`],
  [FooterMessages.gifts, `${Urls.GIFTS}`],
  [FooterMessages.privacy, `${Urls.PRIVACY}`],
  [FooterMessages.terms, `${Urls.TERMS}`],
  [FooterMessages.help, `${Urls.HELP}`],
  [FooterMessages.community],
  [FooterMessages.adPreferences, `${Urls.ADVERTISING_PREFERENCES}`],
  [FooterMessages.doNotSell],
  [FooterMessages.yourPrivacyChoices, `${Urls.PRIVACY_CHOICES}`],
  [FooterMessages.cookieSettings],
];

export const onetrustLinkClassname = 'ot-sdk-show-settings';
